import React from "react";
import { Helmet } from "react-helmet";
import { useNavigate } from "react-router-dom";
import "./App.css";

function Portfolio() {

  const navigate = useNavigate();

  const goToHome = () => {
    navigate("/home");
  };

  return (  
    <div className="portfolio-container">

      <Helmet>
        <title>PRO AI Writing Tools Portfolio | AI Paragraph Generator Projects</title>

        <meta
          name="description"
          content="Explore our AI writing tools portfolio including AI paragraph generator, essay content generator, blog assistant, and article introduction generator built using modern artificial intelligence technology."
        />

        <meta
          name="keywords"
          content="Pro AI Paragraph Generator, AI portfolio, AI writing tools portfolio, AI paragraph generator project, AI content generator tools, Creative Writing AI, Product Description AI, SEO Content Tool, Article Introduction Tool, Social Media Generator, Story Generator, blog content AI assistant, essay generator AI, article introduction generator, artificial intelligence writing tools"
        />

        <link rel="canonical" href="https://proaiparagraph.vercel.app/Portfolio" />

        <meta property="og:title" content="AI Writing Tools Portfolio" />
        <meta
          property="og:description"
          content="Discover AI-powered content generation tools including paragraph generator, essay generator, blog assistant, and creative writing AI."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://proaiparagraph.vercel.app/Portfolio" />
      </Helmet>

      <section className="portfolio-hero">

        <h1>Our PRO AI Writing Tools Portfolio</h1>

        <p>
          Explore our portfolio of powerful <strong>PRO AI writing tools </strong>
          and <strong>PRO AI content generator projects</strong>.
        </p>

      </section>

      <button className="about-btn" onClick={goToHome} style={{marginLeft: "41.5%"}}>
        Generate Paragraph
      </button>

      <section className="portfolio-grid">

        <div className="portfolio-card">
          <h3>AI Paragraph Generator</h3>
          <p>
            Instantly creates high-quality paragraphs based on any topic.
          </p>
        </div>

        <div className="portfolio-card">
          <h3>Essay Content Generator</h3>
          <p>
            Generate structured essay paragraphs for academic writing.
          </p>
        </div>

        <div className="portfolio-card">
          <h3>Blog Content Assistant</h3>
          <p>
            Helps bloggers create article ideas and drafts quickly.
          </p>
        </div>

        <div className="portfolio-card">
          <h3>Article Introduction Tool</h3>
          <p>
            Generate engaging article introductions using AI.
          </p>
        </div>

        <div className="portfolio-card">
          <h3>Topic Idea Generator</h3>
          <p>
            Discover interesting writing topics and ideas instantly.
          </p>
        </div>

        <div className="portfolio-card">
          <h3>Creative Writing AI</h3>
          <p>
            Get inspiration for stories and creative writing.
          </p>
        </div>

        <div className="portfolio-card">
          <h3>SEO Content Tool</h3>
          <p>
            Generate SEO-optimized paragraphs to improve search engine rankings.
          </p>
        </div>

        <div className="portfolio-card">
          <h3>Social Media Generator</h3>
          <p>
            Create engaging posts and captions for social media platforms.
          </p>
        </div>

        <div className="portfolio-card">
          <h3>Email Writing Tool</h3>
          <p>
            Write professional emails quickly using AI assistance.
          </p>
        </div>

        <div className="portfolio-card">
          <h3>Product Description AI</h3>
          <p>
            Generate compelling product descriptions for eCommerce websites.
          </p>
        </div>

        <div className="portfolio-card">
          <h3>Content Rewriter</h3>
          <p>
            Rewrite and improve your existing content for better readability.
          </p>
        </div>

        <div className="portfolio-card">
          <h3>Story Generator</h3>
          <p>
            Generate creative stories and ideas for writers and creators.
          </p>
        </div>

      </section>

      <section className="portfolio-example">

        <h2>Example AI Generated Content</h2>

        <p>
          Artificial Intelligence is transforming modern technology
          and shaping the future of innovation. Using advanced 
          <strong> AI writing tools</strong>, users can generate
          paragraphs, essays, and blog content instantly. From
          automation to intelligent data analysis, AI helps industries
          improve productivity and efficiency. As AI technology
          continues to evolve, <strong>AI content generators </strong>
          are becoming essential tools for education, blogging,
          research, and professional writing.
        </p>

      </section>

    </div>
  );
}

export default Portfolio;